import {
    cakePPFAriaLabel,
    fitnessPPFAriaLabel,
    taskPPFAriaLabel,
    examPPFAriaLabel,
    goalPPFAriaLabel,
} from '../strings.locstring.json';
import loc from 'owa-localize';
import populateCelebrationImages from './populateCelebrationImages';
import type CelebrationObject from '../schema/CelebrationObject';
import { PPF_CELEBRATION_FEATURE } from 'owa-calendar-feature-flags';
import type ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Returns the Celebration Object asociated with a specific charm ID.
 */
export default function getCelebrationObject(
    charmId: number,
    colorScheme: ColorScheme
): CelebrationObject {
    if (isFeatureEnabled(PPF_CELEBRATION_FEATURE)) {
        let aria: string = null;
        let image: string = null;
        let celebrationImages = populateCelebrationImages(colorScheme);
        switch (charmId) {
            case 26:
                aria = loc(cakePPFAriaLabel);
                image = celebrationImages.cake;
                break;
            case 46:
            case 53:
                aria = loc(fitnessPPFAriaLabel);
                image = celebrationImages.fitness;
                break;
            case 55:
                aria = loc(taskPPFAriaLabel);
                image = celebrationImages.task;
                break;
            case 57:
                aria = loc(examPPFAriaLabel);
                image = celebrationImages.exam;
                break;
            case 58:
                aria = loc(goalPPFAriaLabel);
                image = celebrationImages.goal;
                break;
            default:
                return null;
        }

        return {
            ariaLabel: aria,
            image: image,
        };
    }

    return null;
}
